<mat-accordion>
    <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
        class="border-expansion"
        [ngStyle]="{ 'margin-bottom': '15px' }"
    >
        <mat-expansion-panel-header class="border-expansion-header">
            <div>
                <mat-panel-title class="border-expansion-title">
                    {{ data && data.name ? data.name : data.fullName }}
                </mat-panel-title>
                <div
                    class="stt-container"
                    [ngSwitch]="data.status"
                    *ngIf="!noStatus && !(mode && mode === 'simulationAdmins')"
                >
                    <mat-panel-description
                        class="border-expansion-status not-started"
                        *ngSwitchCase="ENUM_STATUS.NOT_STARTED"
                    >
                        {{ 'NotStarted' | translate }}
                    </mat-panel-description>
                    <mat-panel-description class="border-expansion-status running" *ngSwitchCase="ENUM_STATUS.RUNNING">
                        {{ 'Running' | translate }}
                    </mat-panel-description>
                    <mat-panel-description class="border-expansion-status ended" *ngSwitchCase="ENUM_STATUS.ENDED">
                        {{ 'Ended' | translate }}
                    </mat-panel-description>
                </div>
                <div class="stt-container" *ngIf="!noStatus && mode && mode === 'simulationAdmins'">
                    <mat-panel-description class="border-expansion-status invite-send" *ngIf="data.status != 'active'">
                        {{ 'InviteSent' | translate }}
                    </mat-panel-description>
                    <mat-panel-description class="border-expansion-status not-started" *ngIf="data.status == 'active'">
                        {{ 'Active' | translate }}
                    </mat-panel-description>
                </div>
                <!-- <mat-panel-description class="border-expansion-status ended" >
                    NOT STARTED
                </mat-panel-description> -->
            </div>
        </mat-expansion-panel-header>

        <div class="expansion-body" *ngIf="!mode">
            <p>
                Code : <span>{{ data.loginCode ? data.loginCode : data.code }}</span>
            </p>
            <p>
                Participant :
                <a (click)="openParticipantForm(data)">
                    {{ formatCellParticipant(data.participants) }}
                </a>
            </p>
            <p>
                Type : <span>{{ data.simulationTypeName }}</span>
            </p>
            <p>
                Room : <span>{{ data.roomNumber }}</span>
            </p>
            <p>
                Avaliability : <span>{{ formatCell('availability', data) }}</span>
            </p>

            <p>
                Min :<span *ngIf="data.status == ENUM_STATUS.NOT_STARTED"> -</span>
                <app-duration [date]="data.startAtTime" *ngIf="data.status == ENUM_STATUS.RUNNING"></app-duration>
                <span *ngIf="data.status == ENUM_STATUS.ENDED"> {{ formMatCellMin(data) }}</span>
            </p>
            <p style="display: flex">
                Date & Time : <span [innerHTML]="getTemplateDateTime(data ? data : '0')" style="display: flex"></span>
            </p>
            <div class="expansion-body-action" [ngStyle]="{ display: noButton ? 'none' : 'block' }">
                <button
                    mat-button
                    *ngIf="
                        (data.status == ENUM_STATUS.NOT_STARTED || data.status == ENUM_STATUS.ENDED) &&
                        createdBy == data.createdBy
                    "
                    class="btn-action btn-edit"
                    (click)="btnClickAction('edit', data)"
                >
                    {{ 'Btn_Edit' | translate }}
                </button>
                <button
                    mat-button
                    *ngIf="data.status == ENUM_STATUS.NOT_STARTED && createdBy == data.createdBy"
                    class="btn-action btn-start now"
                    (click)="btnClickAction('start now', data)"
                >
                    {{ 'Btn_StartNow' | translate }}
                </button>
                <button
                    mat-button
                    *ngIf="data.status == ENUM_STATUS.RUNNING"
                    class="btn-action btn-join"
                    (click)="btnClickAction('join', data)"
                >
                    {{ 'Btn_Join' | translate }}
                </button>
                <button
                    mat-button
                    *ngIf="data.status == ENUM_STATUS.RUNNING && createdBy == data.createdBy"
                    class="btn-action btn-stop"
                    (click)="btnClickAction('stop', data)"
                >
                    {{ 'Btn_Stop' | translate }}
                </button>
                <button
                    mat-button
                    *ngIf="data.status == ENUM_STATUS.ENDED"
                    class="btn-action btn-view log"
                    (click)="btnClickAction('view log', data)"
                >
                    {{ 'Btn_ViewLog' | translate }}
                </button>
            </div>
        </div>
        <div class="expansion-body" *ngIf="mode && mode === 'users'">
            <p>
                {{ 'Email' | translate }} : <span>{{ data.email }}</span>
            </p>
            <p>
                {{ 'Phone' | translate }} : <span>{{ data.phone }}</span>
            </p>
            <p>
                {{ 'Languages' | translate }} : <span>{{ data.languages }}</span>
            </p>

            <a style="display: flex; align-items: center" (click)="resetPassword(data)">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M3.66675 5.43268H10.1667V3.83268C10.1667 3.23268 9.95564 2.72157 9.53341 2.29935C9.11119 1.87713 8.60008 1.66602 8.00008 1.66602C7.40008 1.66602 6.88897 1.87713 6.46675 2.29935C6.04453 2.72157 5.83341 3.23268 5.83341 3.83268H4.83341C4.83341 2.9549 5.14175 2.20768 5.75841 1.59102C6.37508 0.974349 7.1223 0.666016 8.00008 0.666016C8.87786 0.666016 9.62508 0.974349 10.2417 1.59102C10.8584 2.20768 11.1667 2.9549 11.1667 3.83268V5.43268H12.3334C12.6112 5.43268 12.8473 5.5299 13.0417 5.72435C13.2362 5.91879 13.3334 6.1549 13.3334 6.43268V13.666C13.3334 13.9438 13.2362 14.1799 13.0417 14.3743C12.8473 14.5688 12.6112 14.666 12.3334 14.666H3.66675C3.38897 14.666 3.15286 14.5688 2.95841 14.3743C2.76397 14.1799 2.66675 13.9438 2.66675 13.666V6.43268C2.66675 6.1549 2.76397 5.91879 2.95841 5.72435C3.15286 5.5299 3.38897 5.43268 3.66675 5.43268ZM3.66675 13.666H12.3334V6.43268H3.66675V13.666ZM8.00008 11.3327C8.35564 11.3327 8.65841 11.2105 8.90841 10.966C9.15841 10.7216 9.28341 10.4271 9.28341 10.0827C9.28341 9.74935 9.15841 9.44657 8.90841 9.17435C8.65841 8.90213 8.35564 8.76602 8.00008 8.76602C7.64453 8.76602 7.34175 8.90213 7.09175 9.17435C6.84175 9.44657 6.71675 9.74935 6.71675 10.0827C6.71675 10.4271 6.84175 10.7216 7.09175 10.966C7.34175 11.2105 7.64453 11.3327 8.00008 11.3327ZM3.66675 13.666V6.43268V13.666Z"
                        fill="#17B978"
                    />
                </svg>

                {{ 'Text_ResetPassword' | translate }}</a
            >
            <div class="expansion-body-action" [ngStyle]="{ display: noButton ? 'none' : 'block' }">
                <button class="btn-action btn-edit" (click)="updateUser(data)">
                    {{ 'Edit' | translate }}
                </button>
                <button class="btn-action btn-delete" (click)="deleteUser(data)">
                    {{ 'Delete' | translate }}
                </button>
            </div>
        </div>
        <div class="expansion-body" *ngIf="mode && mode === 'simulationTypes'">
            <p class="desc">Description</p>
            <p>{{ data.description }}</p>

            <div class="expansion-body-action" [ngStyle]="{ display: noButton ? 'none' : 'block' }">
                <button class="btn-action btn-edit" (click)="updateSimulationAdminOrSimulationType(data)">
                    {{ 'Edit' | translate }}
                </button>
                <button class="btn-action btn-delete" (click)="deleteSimulationAdminOrSimulationType(data)">
                    {{ 'Delete' | translate }}
                </button>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>
